(function () {
  const ROOT_ID = 'CollectionAjaxResult';
  const GRID_VIEW_KEY = 'legacy_collection_grid_view';

  function updateSearchParams(mutator) {
    const url = new URL(window.location.href);
    mutator(url.searchParams);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function initSort(root) {
    const sortSelect = root.querySelector('#SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        updateSearchParams((params) => {
          params.set('sort_by', sortSelect.value);
        });
      });
    }

    root.querySelectorAll('.filter-sort').forEach((btn) => {
      btn.addEventListener('click', () => {
        const value = btn.getAttribute('data-value');
        if (!value) return;
        updateSearchParams((params) => {
          params.set('sort_by', value);
        });
      });
    });
  }

  function initFilters(root) {
    const form = root.querySelector('.filter-form');
    if (!form) return;

    const syncFiltersToUrl = () => {
      const checkboxes = Array.from(form.querySelectorAll('input[type="checkbox"][name]'));
      const names = [...new Set(checkboxes.map((input) => input.name))];

      updateSearchParams((params) => {
        names.forEach((name) => params.delete(name));
        checkboxes
          .filter((input) => input.checked)
          .forEach((input) => params.append(input.name, input.value));
      });
    };

    form.addEventListener('change', (event) => {
      if (event.target && event.target.matches('input[type="checkbox"]')) {
        syncFiltersToUrl();
      }
    });
  }

  function initMobileFilterDrawer(root) {
    const trigger = root.querySelector('.collection-filter__btn');
    const filters = root.querySelector('.filter-wrapper');
    if (!trigger || !filters) return;

    trigger.addEventListener('click', () => {
      const open = filters.classList.toggle('is-active');
      trigger.classList.toggle('is-active', open);
    });

    document.addEventListener('click', (event) => {
      if (!filters.classList.contains('is-active')) return;
      if (filters.contains(event.target) || trigger.contains(event.target)) return;
      filters.classList.remove('is-active');
      trigger.classList.remove('is-active');
    });
  }

  function initGridView(root) {
    const grid = root.querySelector('.product-grid');
    if (!grid) return;

    const applyView = (view) => {
      grid.setAttribute('data-view', view);
      root.querySelectorAll('.grid-view-btn').forEach((btn) => {
        btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
      });
      try {
        localStorage.setItem(GRID_VIEW_KEY, view);
      } catch (_) {}
    };

    let initial = grid.getAttribute('data-view');
    try {
      const stored = localStorage.getItem(GRID_VIEW_KEY);
      if (stored) initial = stored;
    } catch (_) {}
    if (initial) applyView(initial);

    root.querySelectorAll('.grid-view-btn[data-view]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.getAttribute('data-view');
        if (view) applyView(view);
      });
    });
  }

  function init() {
    const root = document.getElementById(ROOT_ID);
    if (!root) return;
    initSort(root);
    initFilters(root);
    // Collapsibles are handled by theme.collapsibles in legacy-expanse.js —
    // do not bind a second click handler here (causes open/close flash).
    initMobileFilterDrawer(root);
    initGridView(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
